import request from '@/router/axios'

const DEFAULT_TENANT_CODE = 'ycedu'

export function loginByUsername(tenantCode = DEFAULT_TENANT_CODE, identifier, credential, code, randomStr) {
  const grantType = 'password'
  const scope = 'read'
  if (tenantCode === '') {
    tenantCode = DEFAULT_TENANT_CODE
  }
  return request({
    url: '/sg-user-service/login',
    headers: {
      'Tenant-Code': tenantCode
    },
    method: 'post',
    params: {username: identifier, credential, randomStr, code, grant_type: grantType, scope}
  })
}

/**
 * 根据手机号登录
 */
export function loginBySocial(tenantCode = DEFAULT_TENANT_CODE, social, code) {
  const grantType = 'mobile'
  const scope = 'read'
  if (tenantCode === '') {
    tenantCode = DEFAULT_TENANT_CODE
  }
  return request({
    url: '/sg-user-service/mobile/login',
    headers: {
      'Tenant-Code': tenantCode
    },
    method: 'post',
    params: {mobile: social, code, grant_type: grantType, scope}
  })
}

export function logout() {
  return request({
    url: '/sg-user-service/v1/token/logout',
    method: 'get'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/sg-user-service/v1/user/info',
    method: 'get'
  })
}

export function genCheckCode() {
  return request({
    url: '/sg-user-service/v1/code/gen',
    method: 'get'
  })
}

export function sendSmsCode(tenantCode, mobile, checkCode, randomUuid) {
  return request({
    url: '/sg-user-service/v1/mobile/sendSms/' + tenantCode + '/' + mobile + '/' + checkCode + '/' + randomUuid,
    method: 'post'
  })
}


export function registerByUsername(tenantCode = DEFAULT_TENANT_CODE, identifier,  credential, smsCode, randomStr) {
  if (tenantCode === '') {
    tenantCode = DEFAULT_TENANT_CODE
  }
  return request({
    url: '/sg-user-service/v1/user/anonymousUser/register',
    method: 'post',
    params: {tenantCode, identifier, credential, randomStr, smsCode},
    data: {identifier, credential}
  })
}

export function sendSmsRegister(tenantCode, mobile, checkCode, randomUuid) {
  return request({
    url: '/sg-user-service/v1/mobile/sendSmsRegister/' + tenantCode + '/' + mobile + '/' + checkCode + '/' + randomUuid,
    method: 'post'
  })
}

export function resetPasswordRequest(updateData) {
  return request({
    url: '/sg-user-service/v1/user/anonymousUserByPhoneCode/updatePassword',
    method: 'put',
    data: updateData
  })
}

/**
 * 刷新token
 */
export function refreshToken(token) {
  if(token==undefined|| token==''){
    return ;
  }
  return request({
    url: '/sg-user-service/v1/token/refreshToken',
    headers: {
      'Authorization': token
    },
    method: 'get',
    params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/login.js